import React, { useEffect } from 'react';
import { Check, Clock, Phone, Mail } from 'lucide-react';
import { useQuote } from '../context/QuoteContext';

const SuccessScreen: React.FC = () => {
  const { state } = useQuote();
  
  useEffect(() => {
    const sendNotification = async () => {
      try {
        const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/send-notification`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            contactInfo: state.contactInfo,
            workDescription: state.workDescription,
            priceRange: state.priceRange,
          }),
        });

        if (!response.ok) {
          throw new Error('Failed to send notification');
        }
      } catch (error) {
        console.error('Error sending notification:', error);
      }
    };

    if (state.contactInfo && state.workDescription && state.priceRange) {
      sendNotification();
    }
  }, [state]);
  
  return (
    <div className="py-4 text-center animate-fadeIn">
      <div className="mb-6 flex justify-center">
        <div className="w-16 h-16 bg-black rounded-full flex items-center justify-center">
          <Check size={32} className="text-white" />
        </div>
      </div>
      
      <h2 className="text-xl font-semibold mb-2">Request Submitted!</h2>
      
      <p className="text-gray-600 mb-6">
        Thank you {state.contactInfo?.firstName}! We've received your request and will start gathering quotes.
      </p>
      
      <div className="bg-gray-50 rounded-lg p-4 mb-6">
        <h3 className="font-medium flex items-center justify-center gap-2 mb-4">
          <Clock size={18} /> What Happens Next
        </h3>
        
        <ol className="text-left space-y-3 text-sm">
          <li className="flex gap-3">
            <div className="bg-black text-white w-6 h-6 rounded-full flex items-center justify-center shrink-0">
              1
            </div>
            <p className="text-gray-700">Our team will review your project details within 24 hours</p>
          </li>
          
          <li className="flex gap-3">
            <div className="bg-black text-white w-6 h-6 rounded-full flex items-center justify-center shrink-0">
              2
            </div>
            <p className="text-gray-700">We'll connect with trusted contractors in your area</p>
          </li>
          
          <li className="flex gap-3">
            <div className="bg-black text-white w-6 h-6 rounded-full flex items-center justify-center shrink-0">
              3
            </div>
            <p className="text-gray-700">You'll receive multiple quotes for your consideration</p>
          </li>
        </ol>
      </div>
      
      <div className="text-sm">
        <p className="text-gray-600 mb-3">Have questions? Contact our support team:</p>
        <div className="flex justify-center gap-4">
          <a 
            href="tel:+16162363800 
" 
            className="flex items-center gap-1 text-gray-700 hover:text-black"
          >
            <Phone size={14} /> (616) 236-3800 
          </a>
          <a 
            href="mailto:support@honeydone.com" 
            className="flex items-center gap-1 text-gray-700 hover:text-black"
          >
            <Mail size={14} /> support@honeydone.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default SuccessScreen;